import { createContext, useContext } from 'react';

export interface CheckboxContextValue {
  /** The control's id, so the label can associate itself with it. */
  id: string;
}

export const CheckboxContext = createContext<CheckboxContextValue | null>(null);

export function useCheckboxContext(): CheckboxContextValue {
  const context = useContext(CheckboxContext);

  if (!context) {
    throw new Error(
      'Checkbox sub-components must be rendered inside a <Checkbox>.'
    );
  }

  return context;
}
